<template>

<b-row>
    <b-col>
        <div class="audit-log-mobile" :class="expand ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
            <template v-if="batchDetail.auditTypeId == 12 || batchDetail.auditTypeId == 13">
                <div v-if="!$store.state.isMobile">
                    <div class="collapsible-heading p-0">
                        <div class="d-flex bottom-border">
                            <div :class="companyColor" @click="onToggleExpand">{{batchDetail.time}}</div>
                            <div :class="companyColor" @click="onToggleExpand">
                                {{batchDetail.user}}<br/>
                                <template v-for="(c,i) in companyTree">
                                    {{c}} {{i == companyTree.length - 1 ? '' : '/'}} <br :key="i"/>
                                </template>
                            </div>
                            <div :class="companyColor" @click="onToggleExpand" v-if="adminView"><span :style="`visibility: ${batchDetail.lcrId ? 'visible' : 'hidden'};`">LCR: {{batchDetail.lcrId}}</span></div>
                            <div :class="companyColorDropdownIcon">
                                <b-button href="#" variant="collapsible" :class="expand ? '' : ' collapsed'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseAuditListing" @click="onToggleExpand">
                                    <span class="when-opened">
                                        <font-awesome-icon icon="chevron-down" />
                                    </span>
                                    <span class="when-closed">
                                        <font-awesome-icon icon="chevron-right" />
                                    </span>
                                </b-button>
                            </div>
                        </div>
                    </div>
                    <b-collapse id="collapseAuditListing" :visible="expand" class="collapse--content">
                        <b-col>
							<h5>{{batchDetail.notes}}</h5>
                            <template v-for="logsData in (batchDetail.auditTypeId == 12) ? this.logsDataClosure : this.logsDataRestriction">
                            <b-row v-for="(logItem, y) in Object.values(logsData)"  v-bind:key="'logitemUpdates-'+y+'-'+Math.random()">
                                <b-col class="mb-3">
                                    <div class="collapsible-unique">
                                        <div class="collapsible-entry__details">
                                            <div><img :src="logItem.img" width="30" height="30" /> {{logItem.text}}</div>
                                        </div>

                                        <div class="d-flex collapsible-entry" v-for="lane in logItem.items">
                                            <div class="collapsible-entry__icon">
                                                <div :class="lane.InEffect ? 'status-circle-solid lc-closed' : 'status-circle-solid lc-open'">&nbsp;</div>
                                            </div>
                                            <div class="flex-grow-1">
                                                <div class="d-flex collapsible-entry__title-wrapper">
                                                    <div class="flex-grow-1 collapsible-entry__title">
                                                        <template v-if="batchDetail.auditTypeId == 12">
                                                            {{lane.InEffect ? 'Closed' : 'Opened'}} {{lane.StreetName}} from <b>{{lane.FromStreet}}</b> to <b>{{lane.ToStreet}}</b>
                                                        </template>
                                                        <template v-if="batchDetail.auditTypeId == 13">
                                                            {{lane.InEffect ? 'Placed' : 'Removed'}} {{lane.AffectedStreet}} from <b>{{lane.FromStreet}}</b> to <b>{{lane.ToStreet}}</b> {{getTurningRestrictionName(lane)}} onto <b>{{lane.CrossStreet}}</b>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            </template>
                            <b-row v-if="(batchDetail.auditTypeId == 12) ? isClosureEmpty : isRestrictionEmpty">
                                <b-col class="mb-3">
                                    <div><h5>No changes were made.</h5></div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-collapse>
                </div>
                <audit-log-listing-block v-else :batchDetail="batchDetail" :adminView="adminView" :logs="logs" :lcr="lcr"></audit-log-listing-block>
            </template>
            <template v-else-if="logs">
                <div v-if="!$store.state.isMobile">
                    <div class="collapsible-heading p-0">
                        <div class="d-flex bottom-border">
                            <div :class="companyColor" @click="onToggleExpand">{{batchDetail.time}}</div>
                            <div :class="companyColor" @click="onToggleExpand">
                                {{batchDetail.user}}<br/>
                                <template v-for="(c,i) in companyTree">
                                    {{c}} {{i == companyTree.length - 1 ? '' : '/'}} <br :key="i"/>
                                </template>
                            </div>
                            <div :class="companyColorDropdownIcon">
                                <b-button href="#" variant="collapsible" :class="expand ? '' : ' collapsed'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseAuditListing" @click="onToggleExpand">
                                    <span class="when-opened">
                                        <font-awesome-icon icon="chevron-down" />
                                    </span>
                                    <span class="when-closed">
                                        <font-awesome-icon icon="chevron-right" />
                                    </span>
                                </b-button>
                            </div>
                        </div>
                    </div>
                    <b-collapse id="collapseAuditListing" :visible="expand" class="collapse--content">
                        <b-col>
							<h5>{{batchDetail.notes}}</h5>
							<template v-for="(logItem, x) in this.logsData">
							<b-row v-if="logItem.label" v-bind:key="'logitemlogs-'+x+'-'+Math.random()">
                                <b-col class="mb-3">
                                    <div class="lcr-summary__label">{{$t(`auditLog.laneClosureRequest.${logItem.label}`)}}</div>
									<div v-for="line in logItem.getContent()" class="lcr-summary__value">
										<font-awesome-icon v-if="line.faType" :icon="line.faType" :class="'mr-2 ' + line.faType"></font-awesome-icon><span v-html="line.text"></span></div>
                                </b-col>
                            </b-row>
							</template>
                            <b-row v-if="this.logsData.length == 0">
                                <b-col class="mb-3">
                                    <div><h5>No changes were made.</h5></div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-collapse>
                </div>
                <audit-log-listing-block v-else :batchDetail="batchDetail" :adminView="adminView" :logs="logs" :lcr="lcr"></audit-log-listing-block>
            </template>
            <template v-else>
                <div v-if="!$store.state.isMobile" class="collapsible-heading p-0">
                    <div class="d-flex bottom-border">
                        <div :class="companyColor" >{{batchDetail.time}}</div>
                        <div :class="companyColor" @click="onToggleExpand">
                            {{batchDetail.user}}<br/>
                            <template v-for="(c,i) in companyTree">
                                {{c}} {{i == companyTree.length - 1 ? '' : '/'}} <br :key="i"/>
                            </template>
                        </div>
                        <div :class="companyColor" @click="onToggleExpand" v-if="adminView"><span :style="`visibility: ${batchDetail.lcrId ? 'visible' : 'hidden'};`">LCR: {{batchDetail.lcrId}}</span></div>
                        <div :class="companyColorDropdownIcon">
                            <b-button href="#" variant="collapsible" class=" collapsed" style="visibility: hidden;">
                                <span class="when-opened">
                                    <font-awesome-icon icon="chevron-down" />
                                </span>
                                <span class="when-closed">
                                    <font-awesome-icon icon="chevron-right" />
                                </span>
                            </b-button>
                        </div>
                    </div>
                </div>
                <audit-log-listing-block v-else :batchDetail="batchDetail" :adminView="adminView" :logs="logs" :lcr="lcr"></audit-log-listing-block>
            </template>
        </div>
    </b-col>
</b-row>

</template>

<script>
import AuditLogList from '../models/AuditLogList';
import AuditLogClosure from '../models/AuditLogClosure';
import AuditLogRestriction from '../models/AuditLogRestriction';
import AuditLogListingBlock from '../components/AuditLogListingBlock.vue';
import Format from '../utility/Format';
import LaneClosureRequest from '../models/LaneClosureRequest';

export default {
    name:'LaneClosureUpdatesListing',
    props: ['logs', 'batchDetail', 'lcr', 'adminView'],

    components: {
        AuditLogListingBlock
    },

    data() {
        return {
            expand: false,
        }
    },

    computed: {
        logsData() {
            return new AuditLogList(this.logs).getAuditFields();
        },

        logsDataClosure() {
            return new AuditLogClosure(this.logs).getContent();
        },

        logsDataRestriction() {
            return new AuditLogRestriction(this.logs).getContent();
        },

        isClosureEmpty() {
            let closure = new AuditLogClosure(this.logs).getContent();
            let empty = true;
            closure.forEach(item => {
                if (Object.values(item).length != 0) empty = false
            });
            return empty;
        },

        isRestrictionEmpty() {
            let restriction = new AuditLogRestriction(this.logs).getContent();
            let empty = true;
            restriction.forEach(item => {
                if (Object.values(item).length != 0) empty = false
            });
            return empty;
        },

        batchTitle() {
            if (!this.adminView) {
                if (this.batchDetail.auditTypeId == 1) {
                    return this.$t('auditLog.laneClosureRequest.NewRequest');
                }
                else if (this.batchDetail.auditTypeId == 2) {
                    return this.$t('auditLog.laneClosureRequest.UpdatedRequest');
                }
                else {
                    return this.batchDetail.notes;
                }
            } else {
                return this.batchDetail.notes;
            }
        },

        companyColor() {
            if (this.batchDetail.organizationType == "city") {
                return "flex-grow-1 bg-primary-x-light collapsible-heading__value color-column";
            } else {
                return "flex-grow-1 bg-secondary-light collapsible-heading__value color-column";
            }
        },
        companyColorDropdownIcon() {
            if (this.batchDetail.organizationType == "city") {
                return "bg-primary-x-light collapsible-heading__toggle";
            } else {
                return "bg-secondary-light collapsible-heading__toggle";
            }
        },
        companyTree() {
            if (this.batchDetail.organizationNamePath) {
                let path = this.batchDetail.organizationNamePath;
                path = path.split('|');
                path.pop();
                path.shift();
                return path.reverse();
            }
            return [this.batchDetail.organizationName];
        }
    },

    methods: {
        onToggleExpand() {
            this.expand = !this.expand
        },

        getTurningRestrictionName(lane) {
            return Format.searchById(lane.RestrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).name
        }
    }
}

</script>

<style>

.color-column {
    width: 15%;
}

.plus-circle {
    color: #009933;
}
.minus-circle {
    color: #EF3B39;
}

</style>
